/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mohd Arbaz Khan's Design Portfolio",
  description:
    "A passionate graphics designer who creates visually stunning designs and brand identities that communicate effectively and leave lasting impressions.",
  og: {
    title: "Mohd Arbaz Khan - Graphics Designer Portfolio",
    type: "website",
    url: "http://mohdabrazkhan.com/",
  },
};

//Home Page
const greeting = {
  title: "Mohd Arbaz Khan",
  logo_name: "MohdArbazKhan",
  nickname: "mak_designer",
  subTitle:
    "A passionate graphics designer who creates visually stunning designs and brand identities that communicate effectively and leave lasting impressions.",
  resumeLink:
    "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
  portfolio_repository: "https://www.devilbytes.com/",
  githubProfile: "https://www.devilbytes.com/",
};

const socialMediaLinks = [
  /* Your Social Media Link */

  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mohammad-arbaz-khan?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/makdzinr?igsh=eW5sNGthcDEzbHBy",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/share/1AZTCLaZpy/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Gmail",
    link: "mailto:mohd.arbaz@live.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Graphic Design & Branding",
      fileName: "DesignImg",
      skills: [
        "⚡ Creating visually appealing logos, brand identities, and marketing materials",
        "⚡ Designing user interfaces and user experiences for web and mobile applications",
        "⚡ Developing comprehensive brand guidelines and visual communication strategies",
      ],
      softwareSkills: [
        {
          skillName: "Adobe Photoshop",
          fontAwesomeClassname: "simple-icons:adobephotoshop",
          style: {
            color: "#31A8FF",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF9A00",
          },
        },
        {
          skillName: "Adobe InDesign",
          fontAwesomeClassname: "simple-icons:adobeindesign",
          style: {
            color: "#FF3366",
          },
        },
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF26BE",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Canva",
          fontAwesomeClassname: "simple-icons:canva",
          style: {
            color: "#00C4CC",
          },
        },
        {
          skillName: "CorelDRAW",
          fontAwesomeClassname: "simple-icons:coreldraw",
          style: {
            color: "#00A651",
          },
        },
        {
          skillName: "Sketch",
          fontAwesomeClassname: "simple-icons:sketch",
          style: {
            color: "#F7B500",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Creating wireframes, prototypes, and user journey maps",
        "⚡ Conducting user research and usability testing to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Sketch",
          fontAwesomeClassname: "simple-icons:sketch",
          style: {
            color: "#F7B500",
          },
        },
        {
          skillName: "InVision",
          fontAwesomeClassname: "simple-icons:invision",
          style: {
            color: "#FF3366",
          },
        },
        {
          skillName: "Principle",
          fontAwesomeClassname: "simple-icons:principle",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Marvel",
          fontAwesomeClassname: "simple-icons:marvelapp",
          style: {
            color: "#1FB6FF",
          },
        },
      ],
    },
    {
      title: "Print & Digital Media",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing brochures, flyers, posters, and other print materials",
        "⚡ Creating social media graphics and digital marketing campaigns",
        "⚡ Developing packaging designs and product presentations",
      ],
      softwareSkills: [
        {
          skillName: "Adobe InDesign",
          fontAwesomeClassname: "simple-icons:adobeindesign",
          style: {
            color: "#FF3366",
          },
        },
        {
          skillName: "Adobe Photoshop",
          fontAwesomeClassname: "simple-icons:adobephotoshop",
          style: {
            color: "#31A8FF",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF9A00",
          },
        },
        {
          skillName: "Adobe After Effects",
          fontAwesomeClassname: "simple-icons:adobeaftereffects",
          style: {
            color: "#9999FF",
          },
        },
        {
          skillName: "Adobe Premiere Pro",
          fontAwesomeClassname: "simple-icons:adobepremierepro",
          style: {
            color: "#9999FF",
          },
        },
      ],
    },
    {
      title: "3D Design & Animation",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Creating 3D models and renderings for product visualization",
        "⚡ Developing motion graphics and animated content",
        "⚡ Designing architectural visualizations and interior designs",
      ],
      softwareSkills: [
        {
          skillName: "Blender",
          fontAwesomeClassname: "simple-icons:blender",
          style: {
            color: "#F5792A",
          },
        },
        {
          skillName: "Cinema 4D",
          fontAwesomeClassname: "simple-icons:cinema4d",
          style: {
            color: "#011A6A",
          },
        },
        {
          skillName: "Maya",
          fontAwesomeClassname: "simple-icons:autodesk",
          style: {
            color: "#0696D7",
          },
        },
        {
          skillName: "3ds Max",
          fontAwesomeClassname: "simple-icons:autodesk",
          style: {
            color: "#0696D7",
          },
        },
        {
          skillName: "SketchUp",
          fontAwesomeClassname: "simple-icons:sketchup",
          style: {
            color: "#005F9E",
          },
        },
      ],
    },
  ],
};

// Design Portfolio Sites
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Behance",
      iconifyClassname: "simple-icons:behance",
      style: {
        color: "#1769FF",
      },
      profileLink: "https://www.behance.net/makdzinr",
    },
    {
      siteName: "Dribbble",
      iconifyClassname: "simple-icons:dribbble",
      style: {
        color: "#EA4C89",
      },
      profileLink: "https://dribbble.com/makdzinr",
    },
    {
      siteName: "DeviantArt",
      iconifyClassname: "simple-icons:deviantart",
      style: {
        color: "#05CC47",
      },
      profileLink: "https://www.deviantart.com/makdzinr",
    },
    {
      siteName: "ArtStation",
      iconifyClassname: "simple-icons:artstation",
      style: {
        color: "#13AFF0",
      },
      profileLink: "https://www.artstation.com/makdzinr",
    },
    {
      siteName: "Pinterest",
      iconifyClassname: "simple-icons:pinterest",
      style: {
        color: "#BD081C",
      },
      profileLink: "https://www.pinterest.com/makdzinr",
    },
    {
      siteName: "Uplabs",
      iconifyClassname: "simple-icons:uplabs",
      style: {
        color: "#3ECFB0",
      },
      profileLink: "https://www.uplabs.com/makdzinr",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "National Institute of Design",
      subtitle: "Bachelor of Design in Graphic Design",
      logo_path: "iiitk_logo.png",
      alt_name: "NID Ahmedabad",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied comprehensive design subjects including Typography, Color Theory, Brand Identity, and Visual Communication.",
        "⚡ Apart from this, I have done courses on Digital Design, UI/UX Design, and Design Thinking methodologies.",
        "⚡ I was selected for Merit Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in design projects.",
      ],
      website_link: "https://www.nid.edu",
    },
    {
      title: "Art Institute of Mumbai",
      subtitle: "Diploma in Visual Communication Design",
      logo_path: "iu_logo.png",
      alt_name: "Art Institute Mumbai",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have taken variety of courses related to Advanced Design which correspond to Brand Strategy, Motion Graphics, and Digital Marketing Design.",
        "⚡ Apart from this, I have also done specialization in UI/UX Design. As part of it, I have worked on creating user-centered design solutions for mobile and web applications.",
        "⚡ During my time at institute, I was also associated with design exhibitions. As part of it, I have worked on curating design shows and organizing creative workshops.",
      ],
      website_link: "https://www.artinstitute.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Adobe Certified Expert",
      subtitle: "- Adobe Creative Suite",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.adobe.com/training-and-certification.html",
      alt_name: "Adobe",
      color_code: "#FF0000",
    },
    {
      title: "UI/UX Design Specialization",
      subtitle: "- California Institute of Arts",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/specializations/ui-ux-design",
      alt_name: "CalArts",
      color_code: "#00000099",
    },
    {
      title: "Graphic Design Masterclass",
      subtitle: "- Udemy",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.udemy.com/course/graphic-design-masterclass/",
      alt_name: "Udemy",
      color_code: "#0C9D5899",
    },
    {
      title: "Brand Identity Design",
      subtitle: "- Skillshare",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.skillshare.com/classes/brand-identity-design",
      alt_name: "Skillshare",
      color_code: "#1F70C199",
    },
    {
      title: "Motion Graphics",
      subtitle: "- After Effects Certification",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://www.adobe.com/products/aftereffects.html",
      alt_name: "Adobe",
      color_code: "#D83B0199",
    },
    {
      title: "Typography Fundamentals",
      subtitle: "- Type Institute",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.typeinstitute.com/fundamentals",
      alt_name: "Type Institute",
      color_code: "#1F70C199",
    },
    {
      title: "Digital Marketing Design",
      subtitle: "- Google Digital Garage",
      logo_path: "google_logo.png",
      certificate_link:
        "https://learndigital.withgoogle.com/digitalgarage",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "3D Design & Modeling",
      subtitle: "- Blender Foundation",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.blender.org/certification/",
      alt_name: "Blender",
      color_code: "#00000099",
    },
    {
      title: "Web Design Fundamentals",
      subtitle: "- FreeCodeCamp",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/responsive-web-design",
      alt_name: "FreeCodeCamp",
      color_code: "#2A73CC",
    },
    {
      title: "Color Theory & Application",
      subtitle: "- Design Academy",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.designacademy.edu/color-theory",
      alt_name: "Design Academy",
      color_code: "#4285F499",
    },
    {
      title: "Print Production",
      subtitle: "- Print Institute",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://www.printinstitute.com/production-course",
      alt_name: "Print Institute",
      color_code: "#FFBB0099",
    },
    {
      title: "Design Thinking",
      subtitle: "- IDEO U",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.ideou.com/pages/design-thinking",
      alt_name: "IDEO U",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Freelance and Creative Projects",
  description:
    "I have worked with various clients and agencies as a Graphics Designer, Brand Identity Designer and UI/UX Designer. I have experience in creating visual identities, marketing materials, and digital designs. I love creating impactful designs that communicate effectively and leave lasting impressions.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Senior Graphics Designer",
          company: "Creative Design Studio",
          company_url: "https://www.creativedesignstudio.com/",
          logo_path: "tiktok_logo.png",
          duration: "June 2023 - Present",
          location: "Mumbai, Maharashtra",
          description:
            "Leading design projects for major brands, creating comprehensive brand identities, marketing campaigns, and digital assets. Specializing in logo design, brand guidelines, and visual communication strategies that drive business growth.",
          color: "#000000",
        },
        {
          title: "Brand Identity Designer",
          company: "Brand Solutions Agency",
          company_url: "https://brandsolutions.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - Aug 2021",
          location: "Delhi, India",
          description:
            "Developed brand identities for startups and established businesses. Created logos, business cards, letterheads, and complete brand guidelines. Worked on packaging design and marketing collateral that increased brand recognition by 40%.",
          color: "#0879bf",
        },
        {
          title: "UI/UX Designer",
          company: "Digital Innovation Labs",
          company_url: "https://www.digitalinnovation.com/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Bangalore, Karnataka",
          description:
            "Designed user interfaces for mobile applications and websites. Created wireframes, prototypes, and user journey maps. Collaborated with development teams to ensure pixel-perfect implementation of designs.",
          color: "#9b1578",
        },
        {
          title: "Graphic Designer",
          company: "Print Media Solutions",
          company_url: "https://www.printmedia.com/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Pune, Maharashtra",
          description:
            "Designed print materials including brochures, flyers, posters, and banners. Worked on magazine layouts and newspaper advertisements. Gained experience in print production and color management.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Freelance Projects",
      experiences: [
        {
          title: "Freelance Brand Designer",
          company: "Various Clients",
          company_url: "https://www.behance.net/makdesigner",
          logo_path: "tiktok_logo.png",
          duration: "May 2022 - Present",
          location: "Remote",
          description:
            "Working with international clients on brand identity projects, logo design, and marketing materials. Completed over 50+ successful projects with 5-star ratings on freelance platforms.",
          color: "#000000",
        },
        {
          title: "Social Media Designer",
          company: "E-commerce Brands",
          company_url: "https://www.instagram.com/mak_designer",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Remote",
          description:
            "Created social media graphics, product mockups, and advertising banners for e-commerce brands. Designed Instagram posts, Facebook ads, and promotional materials that increased engagement by 60%.",
          color: "#ee3c26",
        },
        {
          title: "Logo Design Specialist",
          company: "Startup Community",
          company_url: "https://dribbble.com/makdesigner",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Remote",
          description:
            "Specialized in creating unique logos for tech startups and small businesses. Developed brand identity packages including logo variations, color palettes, and typography guidelines.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Community & Volunteering",
      experiences: [
        {
          title: "Design Mentor",
          company: "Design Community India",
          company_url: "https://designcommunity.in/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Mumbai, Maharashtra",
          description:
            "Mentored aspiring designers in graphic design fundamentals, brand identity creation, and portfolio development. Conducted workshops on Adobe Creative Suite and design thinking processes.",
          color: "#4285F4",
        },
        {
          title: "Creative Director",
          company: "College Design Club",
          company_url: "https://www.college.edu/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Mumbai, Maharashtra",
          description:
            "Led the college design club, organizing design competitions, workshops, and exhibitions. Managed a team of 20+ student designers and coordinated with industry professionals for guest lectures.",
          color: "#D83B01",
        },
        {
          title: "Volunteer Designer",
          company: "NGO Design Initiative",
          company_url: "https://www.ngodesign.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Mumbai, Maharashtra",
          description:
            "Provided pro-bono design services for non-profit organizations. Created awareness campaigns, fundraising materials, and digital assets for social causes.",
          color: "#000000",
        },
        {
          title: "Design Community Member",
          company: "Designers United Mumbai",
          company_url: "https://www.designersunited.in/",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Mumbai, Maharashtra",
          description:
            "Active member of the local design community, participating in design challenges, networking events, and skill-sharing sessions. Contributed to open-source design projects and community initiatives.",
          color: "#0C9D58",
        },
        {
          title: "Creative Contributor",
          company: "Design for Good",
          company_url: "https://designforgood.org/",
          logo_path: "dsc_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Remote",
          description:
            "Contributing designs for social impact projects, environmental campaigns, and educational initiatives. Creating visual content that raises awareness about important social issues.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Design Projects",
  description:
    "My design projects showcase a variety of creative solutions including brand identities, UI/UX designs, print materials, and digital graphics. Each project demonstrates my ability to create visually compelling and effective designs.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "Ready to bring your vision to life? I'm available for freelance projects and collaborations. Let's discuss how I can help you with Graphic Design, Brand Identity, UI/UX Design, and Creative Solutions. I typically respond within 24 hours.",
  },
  blogSection: {
    title: "Design Portfolio",
    subtitle:
      "I like to document some of my design experiences and share creative insights from my professional journey as a graphics designer.",
    link: "https://www.behance.net/makdzinr",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Mumbai, Maharashtra, India",
    locality: "Mumbai",
    country: "India",
    region: "Maharashtra",
    postalCode: "400001",
    streetAddress: "Mumbai",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.google.com/maps?q=Mumbai,+Maharashtra,+India",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+91 98765 43210",
  },
};

// Contact Info for alternative contact component
const contactInfo = {
  title: "Contact Me",
  subtitle: "Let's create something amazing together!",
  number: "+91 98765 43210",
  email_address: "mohd.arbaz@live.com",
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  contactInfo,
};
